import { AlertTriangle } from 'lucide-react';
import type { ReactNode } from 'react';

interface FactAlertProps {
  title: string;
  children: ReactNode;
}

/**
 * A moldura do alerta que mora **ao lado do fato que ele qualifica** (decisão
 * 36): conflito de espaço junto de "Local", prazo por porte junto de "Data e
 * Hora".
 *
 * Isto emenda a decisão 19 da 2ª rodada ("contexto → alerta → ação"), que
 * continua válida no que dizia — alerta antes de ação, uma ordem só nos dois
 * tamanhos. O que muda é que o alerta deixa de ser um bloco solto no fim da
 * coluna do revisor e passa a ser uma **anotação do dado**, que é o mesmo
 * argumento levado um passo adiante: alerta longe do dado vira aviso genérico;
 * ao lado do dado, ele é leitura.
 *
 * ⚠️ **Nunca bloqueia** (regra 5 / ADR-004). Ele não desabilita botão, não vira
 * constraint e não exige confirmação — a decisão final é humana. É por isso que
 * é `role="status"` e não `role="alert"`: anotação de contexto não interrompe
 * quem está lendo o documento.
 *
 * ⚠️ **A contrapartida de sair da coluna `lg:sticky`** é que dá para chegar em
 * "Aprovar" sem ter rolado até aqui. Quem cobre isso é `DecisionForm`, que
 * repete os DOIS alertas no ramo `approve`, pela regra: a última tela antes do
 * irreversível repete tudo que desaconselha o irreversível.
 */
export function FactAlert({ title, children }: FactAlertProps) {
  return (
    <div
      role="status"
      className="animate-reveal rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm"
    >
      <p className="flex items-start gap-2 font-medium text-amber-900">
        {/* `mt-0.5`, e não `items-center`: o título quebra em duas linhas numa
            coluna estreita, e um ícone centrado verticalmente num bloco de duas
            linhas descola do texto que ele introduz. */}
        <AlertTriangle aria-hidden="true" className="mt-0.5 size-4 shrink-0" />
        {title}
      </p>
      <div className="mt-1 pl-6 text-amber-900/90">{children}</div>
    </div>
  );
}
